import React from 'react';
import { Line } from 'react-konva';
import { GRID_SPACING } from '../../canvasConstants';
interface GridLayerProps {
  width: number;
  height: number;
  scale: number;
  panX: number;
  panY: number;
  gridStroke?: string;
}

const GridLayer: React.FC<GridLayerProps> = ({ width, height, scale, panX, panY, gridStroke = '#e0e0e0' }) => {
  const lines: React.ReactNode[] = [];
  const startX = Math.floor(-panX / scale / GRID_SPACING) * GRID_SPACING;
  const startY = Math.floor(-panY / scale / GRID_SPACING) * GRID_SPACING;
  const endX = startX + (width / scale) + GRID_SPACING * 2;
  const endY = startY + (height / scale) + GRID_SPACING * 2;
  for (let x = startX; x <= endX; x += GRID_SPACING) {
    lines.push(
      <Line
        key={`v-${x}`}
        points={[x, startY, x, endY]}
        stroke={gridStroke}
        strokeWidth={1}
        listening={false}
      />
    );
  }
  for (let y = startY; y <= endY; y += GRID_SPACING) {
    lines.push(
      <Line
        key={`h-${y}`}
        points={[startX, y, endX, y]}
        stroke={gridStroke}
        strokeWidth={1}
        listening={false}
      />
    );
  }

  return <>{lines}</>;
};

export default GridLayer;
